import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/* 
@function useDeviceDetection
@description - a custom hook that returns a boolean value based on the current screen size of the device
@param {string} breakpoint - the breakpoint to check against
@returns {boolean} - true if the current screen size is less than the breakpoint, false otherwise
@acceptedBreakpoints - 'xs', 'sm', 'md', 'lg', 'xl'
*/

const useDeviceDetection = (breakpoint = 'lg') => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint), { noSsr: true });
};

export default useDeviceDetection;
